<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/cloudflashpayment/select"
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
    >
      <el-form-item label="代理商ID">
        <el-input
          type="text"
          v-model="formModel.userId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="id"
        label="代理商ID"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantCode"
        label="商户号"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="identity"
        label="身份证"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="实名时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "cloudflashpayment",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        userId: "",
        time: "",
      },
      tableData: [],
      time: "",
      params: {},
      page: {},
      submitService: OrganService.cloudflashpaymentList,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        userId: this.formModel.userId.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },

    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        userId: "",
        time: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CloudFlashPayment.vue